<template>
	<div id="page-content">
		<div id="banner">
		
			<div class="banner-slide" v-for="(bannerSlide, index) in bannerSlides" :img="bannerSlide.img">
				<div class="slide-info">
				<h1>{{ bannerSlide.header }}</h1>
				<p>{{ bannerSlide.text }}</p>
				<button type="button" v-if="bannerSlide.button != null" @click="bbl(bannerSlide.href)">{{ bannerSlide.button }}</button>
				</div>
			</div>


			
		</div>
		
		<div class="info-container">
		
			<div class="info-item col-md-4" v-for="infoItem in infoItems">
				<div class="info-icon"><img :src="'static/images/' + infoItem.img"></div>
				<h1>{{  infoItem.header }}</h1>
				<p>{{ infoItem.text }}</p>
			</div>
			
		</div>
		
		<div class="featured-products">
		
			<div class="fp-header">
				<h1>Our Featured Products</h1>
			</div>
			
			<!-- Featured Products -->
			<router-link :to="'/products/product/' + fproduct.code" class="fproduct col-xs-12 col-sm-6 col-md-3" v-for="fproduct in fproducts" :key="fproduct.code">

				<img :src="'static/images/products/' + fproduct.code + '.jpg'" :alt="fproduct.name"/>
				<h2>{{ fproduct.name }}</h2>
				<p v-if="!disabled">Php {{ formatMoney(fproduct.price) }}</p>
				<span>{{ fproduct.categoryName }}</span>
			</router-link>

			
			<div class="clearboth"></div>
			<div class="cta-section" style="margin-top: 20px;">
				<router-link to="/products">View All Products</router-link>
			</div>
			
		</div>
		
		<div class="link-section">
			<h1>With over 250 branches across the Philippines</h1>
			<router-link to="/locations">View Locations</router-link>
		</div>
		
	</div>
</template>

<script>
	export default{
		data(){
			return {
				infoItems: [
					{
						img: 'e.svg',
						header: 'Trusted Product',
						text: 'Established in 1987, Mutual Success Lighting Fixture Inc., has maintained its position as a quality lighting provider in the industry.'
					},
					{
						img: 'e.svg',
						header: 'Quality-Tested',
						text: 'With over twenty-five (25) years of continuous innovation, customer service and excellence, the company relatively expanded, numerically evident by the availability of product lines in more than 250 major depots and DIY\'s nationwide.'
					},
					{
						img: 'e.svg',
						header: 'Light-Wise',
						text: 'Mutual Success Lighting Fixture Inc. offers all types of lighting requirements. From ambient lighting to general lighting, from accent and task lighting to outdoor and industrial lighting; all of which have the objective of providing lighting needs and satisfaction essential to daily living.'
					}
				],

				fproducts: [],
				
				bannerSlides: [
					{
						img: 'a.jpeg',
						header: 'Apollo Lightings',
						text: 'Your Light Partner', 
						button: 'View Products',
						href: '/products'
					}
				],

				disabled: true
			}
		},
		methods: {
			formatMoney: formatMoney,
			bbl: function(link){
				this.$router.push({path: link});
			}
		},
		created(){
			var self = this;
			$.ajax({
				url: 'static/php/featuredproducts.php',
				success: function(data){
					data = JSON.parse(data);
					self.fproducts = data;
				}
			});
		},
		mounted(){
			relativeTo('nav', this.$el);

			//Assign Background Images
			$('.banner-slide').each(function(){
				$(this).css({
					"background": 'url("static/images/' + $(this).attr('img') + '") no-repeat center center',
					"background-size": "cover"
				});
			});	
			

			function HomeResponsive(){
				$('.banner-slide').css({
					"height": $(window).outerHeight() - $('#nav').outerHeight() + "px"
				});

				$('.slide-info').each(function(index){
					$(this).css({
						"top": "calc(50% - " + ($(this).outerHeight() / 2) + "px)",
						"left": "calc(50% - " + ($(this).outerWidth() / 2) + "px)"
					})
				});
			}

			HomeResponsive();
			$(window).on("resize.Home", HomeResponsive);

		},
		destroyed(){
			$(window).off("resize.Home");
		}
	}
</script>


// WEBPACK FOOTER //
// Home.vue?1cac7b9c